/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ReportForFirmwareGroupsByStbGroupResponseGroupMapEntries,
    ReportForFirmwareGroupsByStbGroupResponseGroupMapEntriesFromJSON,
    ReportForFirmwareGroupsByStbGroupResponseGroupMapEntriesFromJSONTyped,
    ReportForFirmwareGroupsByStbGroupResponseGroupMapEntriesToJSON,
} from './ReportForFirmwareGroupsByStbGroupResponseGroupMapEntries';

/**
 * 
 * @export
 * @interface ReportForFirmwareGroupsByStbGroupResponse
 */
export interface ReportForFirmwareGroupsByStbGroupResponse {
    /**
     * 
     * @type {Array<ReportForFirmwareGroupsByStbGroupResponseGroupMapEntries>}
     * @memberof ReportForFirmwareGroupsByStbGroupResponse
     */
    groupMapEntries: Array<ReportForFirmwareGroupsByStbGroupResponseGroupMapEntries>;
}

export function ReportForFirmwareGroupsByStbGroupResponseFromJSON(json: any): ReportForFirmwareGroupsByStbGroupResponse {
    return ReportForFirmwareGroupsByStbGroupResponseFromJSONTyped(json, false);
}

export function ReportForFirmwareGroupsByStbGroupResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReportForFirmwareGroupsByStbGroupResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'groupMapEntries': ((json['groupMapEntries'] as Array<any>).map(ReportForFirmwareGroupsByStbGroupResponseGroupMapEntriesFromJSON)),
    };
}

export function ReportForFirmwareGroupsByStbGroupResponseToJSON(value?: ReportForFirmwareGroupsByStbGroupResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'groupMapEntries': ((value.groupMapEntries as Array<any>).map(ReportForFirmwareGroupsByStbGroupResponseGroupMapEntriesToJSON)),
    };
}

